import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import InOutFieldAreasStore from '../services/InOutFieldAreas/InOutFieldAreasStore';
import InOutFieldAreasContext from '../services/InOutFieldAreas/InOutFieldAreasContext';
import InOutFieldAreasService from '../services/InOutFieldAreas/InOutFieldAreasService';
import { FieldSettings } from './FieldSettings';
import { InOutFieldAreaEdit, InOutFieldAreaNew } from './InOutFieldAreaForm';
import * as pages from '../components/pageComponents';

import { 
  Confirmation,
  Information
} from '../components/modals/common/';
import Scroller from '../components/Scroller';
import { messageUtility } from '../utilities/messageUtility';
import styles from '../styles/componentStyle/inOutFieldAreas/InOutFieldAreas.scss';
import { DIALOG_STATUS } from '../utilities/constants';
import _urlParamManager from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';

/**
 * エリア一覧画面
 */
export class InOutFieldAreas extends React.Component {
  constructor(props) {
    super(props);
    this.pages = _.merge(pages, pages.setting);
    _urlParamManager.setDelegate(urlparam => {
      if (
        urlparam[this.props.vw - 1] &&
          urlparam[this.props.vw - 1].split(':')[0] != 'InOutFieldAreas'
      ) {
        this.props.loadPage(this.pages[urlparam[this.props.vw - 1].split(':')[0]]);
        setTimeout(() => {
          EventManager.trigger(EventType.LAYOUT_UPDATE, {});
        }, 1);
      }
    });
  }

  areaSwitch (
    label,
    switchTextArray,
    checked,
    toggleUseLocationInfoFlg,
    id
  ) {
    return (
      <div className='switch'>
        <span className='switch__label'>
          {label && <span>{label}</span>}
          {switchTextArray && (
            checked ? (
              <span className="area-on">{switchTextArray[0]}</span>
            )
            : (
              <span className="area-off">{switchTextArray[1]}</span>
            )            
          )}
        </span>
        <label htmlFor={`toggle-area-${id}`} className='toggle'>
          <input
            type='checkbox'
            checked={checked}
            id={`toggle-area-${id}`}
            onChange={() => toggleUseLocationInfoFlg(id)}
          />
          <div className='toggle__item' />
        </label>
      </div>
    );
  }

  renderAreaList(
    areas,
    isLoading,
    showLocationInfoFlg,
    selectDeleteArea,
    downloadAreaQR,
    toggleUseLocationInfoFlg
  ) {
    if (_.isEmpty(areas) && !isLoading) {
      return <div>{data.no_areas}</div>;
    }

    return (
      <ul>
        {_.map(areas, (area) => (
          <li key={area.id}>
            <span>{area.name}</span>
            {!!showLocationInfoFlg && this.areaSwitch(            
              data.area_status,
              ['ON', 'OFF'],
              area.use_location_info_flg,
              toggleUseLocationInfoFlg,
              area.id
            )}
            <button
              className='btn--sub'
              onClick={() => downloadAreaQR(area.id)}
            >
              {data.button.qr_download}
              </button>
            <button
              className='btn'
              onClick={() => InOutFieldAreasService.handleLoadPage(InOutFieldAreaEdit, 'InOutFieldAreaEdit', this.props, area.id)}
            >
              {data.button.edit}
            </button>
            <button
              className='btn--negative'
              onClick={() => selectDeleteArea(area)}
            >
              {data.button.delete}
            </button>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    return (
      <InOutFieldAreasStore {...this.props} >
        <InOutFieldAreasContext.Consumer>
          {({             
            areas,
            isShowNotExistFieldIdDialog,
            deleteItem, 
            informationModal,
            dialogStatus,
            isLoading,
            showLocationInfoFlg,
            selectDeleteArea,
            clearDeleteArea,
            deleteArea,
            downloadAreaQR,
            closeNotExistFieldIdDialog,
            closeDialog,
            toggleUseLocationInfoFlg
           }) => (
            <React.Fragment>
              <div id='main' className='main field-areas'>
                <Helmet title={data.title} />
                <div className={`${styles.header} main__header`}>
                  <button
                    className='btn-text--sm'
                    onClick={() => {                      
                      _urlParamManager.setPage('FieldSettings', this.props.vw);
                      this.props.loadPage(FieldSettings);
                      setTimeout(() => {
                        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
                      }, 1);
                    }}>
                    <i className='i-back--blue i-2x vertical-middle' />
                    {data.field_settings}
                  </button>
                  <h1>{data.title}</h1>
                </div>

                <Scroller>
                  <div className={`${styles.form} main__body`}>
                    <div className='setting-header'>
                      <div className='field-areas-main__header'>
                        <div className='setting-header__item'>
                          <button
                            className='btn'
                            type='submit'
                            onClick={() => {
                              InOutFieldAreasService.handleLoadPage(InOutFieldAreaNew, 'InOutFieldAreaNew', this.props)}
                            }
                          >
                            {data.button.create}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className={`${styles.table} field-areas-main__body`}>
                      <div className='form-list form-list-default form-list-default--space'>
                        <div className='subtitle'>
                          <h2>{data.subtitle}</h2>
                          <span>{data.copyright_text}</span>
                        </div>
                        {this.renderAreaList(areas, isLoading, showLocationInfoFlg, selectDeleteArea, downloadAreaQR, toggleUseLocationInfoFlg)}
                      </div>
                    </div>
                  </div>
                </Scroller>
              </div>
              <Confirmation
                rootClassName={'area-delete'}
                visible={!_.isEmpty(deleteItem)}
                title={data.confirmation.delete}
                confirmButtonText={data.button.delete}
                cancelButtonText={data.button.back}
                message={`エリア名： ${deleteItem.name}`}
                isNegative={true}
                onCancel={() => clearDeleteArea()}
                onConfirm={() => deleteArea()}
              />
              <Information
                message={messageUtility.getMessage('E-002-001-006')}
                buttonText={messageUtility.getMessage('I-000-008')}
                visible={isShowNotExistFieldIdDialog}
                onClose={() => closeNotExistFieldIdDialog()}
              />
              <Information
                rootClassName={
                  informationModal.message &&
                  informationModal.message.length > 28
                    ? `wide-dialog-md`
                    : ''
                }
                visible={
                  dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
                }
                title={informationModal.title}
                message={informationModal.message}
                buttonText={informationModal.buttonText}
                onClose={() => closeDialog()}
              />

            </React.Fragment>
          )}
        </InOutFieldAreasContext.Consumer>
      </InOutFieldAreasStore>
    );
  }
}

// 定数
const data = {
  title: "エリア設定",
  field_settings: "現場設定",
  no_areas: "存在するエリアがありません。",
  subtitle: "エリア一覧",
  area_status: "GPS判定",
  button: {
    edit: "編集",
    delete: "削除",
    qr_download: "QR出力",
    create: "新規追加",
    back: "戻る",
  },
  confirmation: {
    delete: "本当に削除しますか",
  },
  copyright_text: "※QRコードは(株)デンソーウェーブの登録商標です。",
};


// WEBPACK FOOTER //
// ./src/pages/InOutFieldAreas.jsx